module.exports = __webpack_public_path__ + "assets/bf-de.b4203d08.svg";